import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeader } from './ui/SectionHeader';
export function Mechanism() {
  return <section className="py-24 bg-emerald-900 text-ivory relative overflow-hidden" data-id="element-71">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-72">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gold" data-id="element-73" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gold" data-id="element-74" />
        <div className="absolute top-1/2 left-0 w-full h-px bg-gold" data-id="element-75" />
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-76">
        <FadeIn data-id="element-77">
          <span className="text-gold font-sans text-xs font-bold tracking-[0.2em] uppercase mb-6 block" data-id="element-78">
            The Unique Mechanism
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-gold mb-10" data-id="element-79">
            The Heritage Intelligence Stack
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-80">
          <p className="text-xl font-serif italic text-ivory/90 mb-8 max-w-2xl mx-auto" data-id="element-81">
            This isn't just a language guide; it's a cultural DNA transplant.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-82">
          <p className="text-lg text-ivory/80 font-sans font-light leading-relaxed max-w-3xl mx-auto" data-id="element-83">
            Built on the "Respect-First" linguistic framework, this protocol
            focuses on the{' '}
            <strong className="text-gold font-normal" data-id="element-84">
              "Trinity of Connection": Tone, Timing, and Title.
            </strong>{' '}
            It teaches you how to speak from your chest, catch a waiter's eye
            without being rude, and use specific "honorific" anchors that signal
            you are a person of substance.
          </p>
        </FadeIn>
      </div>
    </section>;
}